import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";
import type { AxiosProgressEvent } from "axios";

export const BulkSenderService = {
  send: (form: FormData) => {
    return HTTP.post<any, any>(
      `${API_ENDPOINT.CORE}base-clients/v4.0/send-message-to-base`,
      form
    );
  },

  report: (account_id: number, init: string, end: string) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}base-clients/v4.0/get-sends/${account_id}`,
      { params: { init, end, new: "true" } }
    );
  },

  downloadReport: (id_base_clients: number) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}base-clients/v4.0/download-send`,
      { params: { id_base_clients } }
    );
  },
  downloadZip: (
    params: any,
    onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void
  ) => {
    return HTTP.get(`${API_ENDPOINT.CORE}stadistics/download-send-zip`, {
      params,
      responseType: "blob",
      onDownloadProgress,
    });
  },
};
